define("shared/components/shared/address-fields/suggestions", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#unless @hideTitle}}
    <label class="u--m__b__xs {{@qaClassInputLabel}}" data-test-id="shipping-address">
      {{t "account.subscription.billing.address.title"}}
    </label>
    <p class="u--text--sm u--text--light u--m__b" data-test-id="address-tax-text">
      {{t "account.subscription.billing.address.description"}}
    </p>
  {{/unless}}
  
  <fieldset class={{concat-classes "tCK--suggestionsWrapper" (if @hideSubmitButton "u--p__0")}}>
    <p class="tCK--suggestions__title">
      {{svg-jar "warning" class="o--icon"}}
      {{t "account.subscription.billing.address.confirm.title"}}
    </p>
    <p class="u--m__b">{{t "account.subscription.billing.address.confirm.description_suggestion"}}</p>
    {{! Suggested Address }}
    <div class="tCK--suggestionsCard">
      <input
        checked
        class="tCK--suggestionsCard__input"
        id="suggestedAddress"
        name="address"
        type="radio"
        value="suggested"
        {{on "change" (fn @handleChange "suggested")}}
      />
      <label class="tCK--suggestionsCard__label" for="suggestedAddress">
        {{t "account.subscription.billing.address.suggested_address"}}
        <span class="u--text--base" data-test-id="address">{{this.suggestedAddress}}</span>
      </label>
    </div>
    {{! Entered Address }}
    <div class="tCK--suggestionsCard">
      <input
        class="tCK--suggestionsCard__input"
        data-test-id="entered_address_input"
        id="unsavedAddress"
        name="address"
        type="radio"
        value="entered"
        {{on "change" (fn @handleChange "entered")}}
      />
      <label class="tCK--suggestionsCard__label" for="unsavedAddress">
        {{t "account.subscription.billing.address.entered_address"}}
        <span class="u--text--base" data-test-id="address">{{@enteredAddress}}</span>
      </label>
      <Shared::Ui::Button
        @isDisabled={{@isDisabled}}
        @onClick={{@setEditingAddress}}
        @text={{t "shared_words.edit"}}
        @variant="outline"
        aria-label={{t "shared_words.edit"}}
        data-test-id="edit-address-button"
      />
    </div>
    {{#unless @hideSubmitButton}}
      <Shared::Ui::Button
        @text={{t "account.subscription.billing.address.confirm.cta"}}
        @variant="default"
        class="tCH--btn--primary o--btn--block u--m__t qa--confirm_save_address__btn"
        data-test-id="save-button"
        type="submit"
      />
    {{/unless}}
  </fieldset>
  */
  {
    "id": "FVdFMwds",
    "block": "[[[41,[51,[30,1]],[[[1,\"  \"],[10,\"label\"],[15,0,[29,[\"u--m__b__xs \",[30,2]]]],[14,\"data-test-id\",\"shipping-address\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"account.subscription.billing.address.title\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__b\"],[14,\"data-test-id\",\"address-tax-text\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"account.subscription.billing.address.description\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,\"fieldset\"],[15,0,[28,[37,2],[\"tCK--suggestionsWrapper\",[52,[30,3],\"u--p__0\"]],null]],[12],[1,\"\\n  \"],[10,2],[14,0,\"tCK--suggestions__title\"],[12],[1,\"\\n    \"],[1,[28,[35,4],[\"warning\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n    \"],[1,[28,[35,1],[\"account.subscription.billing.address.confirm.title\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--m__b\"],[12],[1,[28,[35,1],[\"account.subscription.billing.address.confirm.description_suggestion\"],null]],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tCK--suggestionsCard\"],[12],[1,\"\\n    \"],[11,\"input\"],[24,\"checked\",\"\"],[24,0,\"tCK--suggestionsCard__input\"],[24,1,\"suggestedAddress\"],[24,3,\"address\"],[24,2,\"suggested\"],[24,4,\"radio\"],[4,[38,5],[\"change\",[28,[37,6],[[30,4],\"suggested\"],null]],null],[12],[13],[1,\"\\n    \"],[10,\"label\"],[14,0,\"tCK--suggestionsCard__label\"],[14,\"for\",\"suggestedAddress\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"account.subscription.billing.address.suggested_address\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"u--text--base\"],[14,\"data-test-id\",\"address\"],[12],[1,[30,0,[\"suggestedAddress\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tCK--suggestionsCard\"],[12],[1,\"\\n    \"],[11,\"input\"],[24,0,\"tCK--suggestionsCard__input\"],[24,\"data-test-id\",\"entered_address_input\"],[24,1,\"unsavedAddress\"],[24,3,\"address\"],[24,2,\"entered\"],[24,4,\"radio\"],[4,[38,5],[\"change\",[28,[37,6],[[30,4],\"entered\"],null]],null],[12],[13],[1,\"\\n    \"],[10,\"label\"],[14,0,\"tCK--suggestionsCard__label\"],[14,\"for\",\"unsavedAddress\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"account.subscription.billing.address.entered_address\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"u--text--base\"],[14,\"data-test-id\",\"address\"],[12],[1,[30,5]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,7],[[16,\"aria-label\",[28,[37,1],[\"shared_words.edit\"],null]],[24,\"data-test-id\",\"edit-address-button\"]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[30,6],[30,7],[28,[37,1],[\"shared_words.edit\"],null],\"outline\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[51,[30,3]],[[[1,\"    \"],[8,[39,7],[[24,0,\"tCH--btn--primary o--btn--block u--m__t qa--confirm_save_address__btn\"],[24,\"data-test-id\",\"save-button\"],[24,4,\"submit\"]],[[\"@text\",\"@variant\"],[[28,[37,1],[\"account.subscription.billing.address.confirm.cta\"],null],\"default\"]],null],[1,\"\\n\"]],[]],null],[13]],[\"@hideTitle\",\"@qaClassInputLabel\",\"@hideSubmitButton\",\"@handleChange\",\"@enteredAddress\",\"@isDisabled\",\"@setEditingAddress\"],false,[\"unless\",\"t\",\"concat-classes\",\"if\",\"svg-jar\",\"on\",\"fn\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/address-fields/suggestions.hbs",
    "isStrictMode": false
  });
  class SuggestionsComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _defineProperty(this, "suggestedAddress", void 0);
      this.suggestedAddress = this.args.suggestedAddress;
    }
  }
  _exports.default = SuggestionsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SuggestionsComponent);
});